import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import Wallet from './Wallet';
import Panel from '../Panel/Panel';

export default class WalletPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
    };
  }

  onResize = () => {
    this.setState({ width: window.innerWidth });
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);

    document.body.classList.add('wallet-page');
  }

  componentWillUnmount() {
    document.body.classList.remove('wallet-page');

    window.removeEventListener('resize', this.onResize);
  }

  render() {
    const {
      match: {
        params: { activeForm },
      },
    } = this.props;

    return (
      <div className="wallet-page__wrapper">
        <Wrapper width={this.state.width}>
          <div className="wallet-page__content">
            <Panel>
              <Wallet activeForm={activeForm} showBalance={false} />
            </Panel>
          </div>
        </Wrapper>
      </div>
    );
  }
}

function Wrapper({ children, width }) {
  return width <= 960 ? (
    children
  ) : (
    <Scrollbars hideTracksWhenNotNeeded={true}>{children}</Scrollbars>
  );
}



// WEBPACK FOOTER //
// ./app/components/Wallet/WalletPage.jsx